import { Injectable } from "@angular/core";
import { AlertController, Platform } from "@ionic/angular";

@Injectable({
    providedIn: 'root'
  })
  export class NativeService {
    constructor(
        private platform: Platform,
        public alertController: AlertController
    ){

    }

    async OnlyAlert(header,subtitle,message) {
      const alert = await this.alertController.create({
        cssClass: 'classOnlyAlert',
        header: header,
        subHeader: subtitle,
        message: message,
        buttons: ['OK']
      });
  
      await alert.present();
      const { role } = await alert.onDidDismiss();
      return role;
    }

    async AlertConfirm(header,message) {
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: `${header}`,
        message: `<strong>${message}</strong>`,
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            id: 'cancel-button'
          }, {
            text: 'Ok',
            role : 'success',
            id: 'confirm-button'
          }
        ]
      });
      await alert.present();
      const { role } = await alert.onDidDismiss();
      return role;
    }

    check_isWeb () {
        return ( this.platform.is('mobileweb') || this.platform.is('desktop') );
    }

    
  }